module.exports = __webpack_public_path__ + "img/image_big_logo.5b67f92c.png";